// Central test-id registry for stable QA selectors.
export const TID = {
  nav: "site-nav",
  navLink: (id) => `nav-link-${id}`,
  navResume: "nav-resume-btn",
  hero: "hero-section",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  heroStatus: "hero-status",
  about: "about-section",
  stack: "stack-section",
  work: "work-section",
  projectCard: (id) => `project-card-${id}`,
  projectOpen: (id) => `project-open-${id}`,
  caseStudy: "case-study-panel",
  caseStudyClose: "case-study-close",
  experience: "experience-section",
  contact: "contact-section",
  contactEmail: "contact-email-btn",
  contactResume: "contact-resume-btn",
  footer: "site-footer",
  backToTop: "back-to-top",
};
